<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md8 sm10>
          <h3 class="text-center">Create / Edit A Lab Request</h3>
          <v-card>
            <v-card-title class="py-1">
              <v-spacer></v-spacer>
              <v-btn small color="error" outlined @click="goTo(update_link)">Cancel</v-btn>
            </v-card-title>
            <v-card-text>
              <form @submit.prevent="saveTest(test)">
                <v-autocomplete label="Choose Client" v-model="test.client_id" required="required" :items="clients" item-text="name" item-value="id" name="Client" v-if="clients" readonly></v-autocomplete>
                <v-autocomplete label="Choose Lab Provider" v-model="laboratory" required="required" :items="laboratories" item-text="name" return-object name="Laboratory" prepend-inner-icon="mdi-hospital-building"></v-autocomplete>
                <v-autocomplete label="Choose Test" prepend-inner-icon="mdi-flask" :items="laboratory_tests" v-model="test.laboratory_test_id" item-value="id" item-text="test_name" :error="errors && errors.laboratory_test_id" v-show="laboratory && laboratory.id" chips name="Laboratory Tests">
                  <template v-slot:selection="data">
                    <v-chip v-bind="data.attrs"  :input-value="data.selected">
                      {{ data.item.test_name }} - {{ data.item.currency }}{{ data.item.cost }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="typeof data.item == 'object'">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.test_name"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.category"></v-list-item-subtitle>
                        <v-list-item-subtitle v-html="data.item.currency + ' ' + data.item.cost"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
                <v-btn small text v-if="!overridingprice && test.laboratory_test_id" @click="overridingprice = true" style="display: block;" class="mb-1">
                  <v-icon left>fa-refresh</v-icon>Override Price
                </v-btn>
                <v-text-field label="Cost" prepend-inner-icon="mdi-cash" v-model="test.cost" type="number" min="0" step="0.01" :prefix="labtest.currency" v-if="overridingprice"></v-text-field>
                <v-btn small type="submit" class="primary pull-right" :loading="processing" :disabled="!test.laboratory_test_id">Next</v-btn><br>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const EditLabTestRequest =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "client-tests" */ '@/Components/ClientTests/edit')

  export default {
    name: 'CreateLabRequest',
    layout,
    props: [
      'laboratories', 'update_link', 'clients', 'patient_test', 'errors'
    ],
    components: {
      EditLabTestRequest,
    },
    metaInfo () {
      return {
        title: 'Create A Lab Request',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        test: this.patient_test,
        overridingprice: false,
        processing: false,
        laboratory: {}
      }
    },
    methods: {
      saveTest (test) {
        this.processing = true;
        this.$inertia.put(this.update_link, test, {
          preserveScroll: true,
          preserveState: false,
          onFinish: () => {
            this.processing = false
          },
          onSuccess: () => {
            swal({ title: 'Updated', type: 'success', timer: 7500 })
            this.$inertia.visit(this.update_link)
          }
        })
      },
    },
    computed: {
      laboratory_tests () {
        return this.laboratory.laboratory_tests
      },
      labtest () {
        let id = this.test.laboratory_test_id
        if (!id) {
          return {
            currency: 'KES'
          }
        } else {
          let labtests = this.laboratory.laboratory_tests
          let selected = labtests.filter((tests) => {
            return tests.id === id
          })
          return selected[0]
        }
      }
    },
  }
</script>
